import qs from "qs";
import axios from "@/plugins/axios";

const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;

export default class BaseResourceService {
  static get apiUrl() {
    return BASE_API_URL;
  }

  static get baseURL() {
    return "";
  }

  static get(queryParams = {}) {
    let query = "?" + qs.stringify(queryParams, { encode: false });
    // let requestString = filters ? this.baseURL+query : this.baseURL;
    return axios
      .get(this.baseURL + query)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static find(id) {
    return axios
      .get(this.baseURL + "/" + id)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static create(attributes) {
    return axios
      .post(this.baseURL, attributes)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static update(id, attributes) {
    return axios
      .post(this.baseURL + "/" + id, attributes)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static delete(ids) {
    return axios
      .post(this.baseURL + "/delete", { ids: ids })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static _shouldLogout(error) {
    if (error.hasOwnProperty('response')) {
      if (error.response.status === 401 && error.response.data.message && (error.response.data.message.toLowerCase()).includes('unauthenticated')) {
        window.location.href = '/';
      } else if (error.response.status === 403 && error.response.data.intent === 'logout') {
        window.location.href = '/';
      }
    }
  }

  // static _cancelRequest(cancelPrevious, method_name) {
  //   if (!cancelPrevious) {
  //     return {};
  //   }
  //   let name = method_name + '_cancel_token';
  //   if (typeof this[name] !== typeof undefined) {
  //     this[name].cancel("Operation canceled due to new request.");
  //   }
  //   this[name] = axios.CancelToken.source();
  //   return {cancelToken: this[name].token};
  // }
}
